import { useEffect, useState, useCallback } from "react";
import api, { apiErr } from "./api";

export function useFetch(url, params, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refetch = useCallback(() => {
    setLoading(true);
    api
      .get(url, { params })
      .then((r) => setData(r.data))
      .catch((e) => setError(apiErr(e)))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, JSON.stringify(params)]);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps.length ? deps : [url, JSON.stringify(params)]);

  return { data, loading, error, refetch, setData };
}
